import React from "react";
import CascadingApprovalSummaryTable from "./CascadingApprovalSummaryTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const CascadingApprovalSummaryIndex = () => (
  <ReportProgramsPage
    TableComponent={CascadingApprovalSummaryTable}
    loadingMessage="Loading cascading approval summary..."
  />
);

export default CascadingApprovalSummaryIndex;
